import { useParams } from 'react-router-dom';
import { useAppSelector } from 'redux/store';
import { AccountParams } from '../types';

export const useGetCurrentAccount = () => {
    const params: AccountParams = useParams();
    const accountId = parseInt(params.accountId);
    const currentAccount = useAppSelector((state) => state.accounts.accounts?.find((a: { id: number }) => a.id === accountId));
    return currentAccount;
};
